import React, { useCallback, useMemo } from 'react';
import Icon from '../../../../../../components/Icon';
import IconWrap from '../../../../../../components/IconWrap';
import TableAdvanced from '../../../../../../components/TableAdvanced';
import RowSubComponent from '../RowSubComponent';
import User from '../../../../../../components/User';
import Place from '../../../../../../components/Place';
import { format, fromUnixTime } from 'date-fns';
import { useTranslation } from 'react-i18next';


const TableUsers = ({ users, onClickEdit, onClickDelete }) => {
    const { t } = useTranslation()
    const columns = useMemo(() => [
        {
            Header: t('Imie i Nazwisko'),
            accessor: 'username',
            Cell: ({ row }) => {
                const user = row.original?.user;
                return (
                    <User
                        user={user}
                        showShortcut
                    />
                )
            }
        },
        {
            Header: t('Uprawnienia'),
            accessor: 'role_name'
        },
        {
            Header: t('Obiekt'),
            accessor: 'place_name',
            Cell: ({ row, cell: { value } }) => {
                const place = row.original?.place_id;
                if (!value) return t('brak');
                return (
                    <Place
                        name={value}
                        logo={place?.logo}
                    />
                );
            }
        },
        {
            Header: t('Dział'),
            accessor: 'department_name',
            Cell: ({ cell: { value } }) => {
                return value ? value : t('brak');
            }
        },
        {
            Header: t('Data ostatniego logowania'),
            accessor: 'login_at',
            Cell: ({ cell: { value } }) => {
                return value ? format(fromUnixTime(value), 'dd.MM.yyyy HH:mm') : t("brak");
            }
        },
        {
            Header: () => null,
            id: 'expander',
            disableResizing: true,
            Cell: ({ row }) => (
                <IconWrap rotate={row.isExpanded ? 0 : -180}><Icon name="arrow" /></IconWrap>
            ),
            width: 30
        },
    ], [t]);

    const renderRowSubComponent = useCallback(
        ({ row }) => (
            <RowSubComponent
                row={row}
                onClickEdit={onClickEdit}
                onClickDelete={onClickDelete}
            />
        ),
        [onClickEdit, onClickDelete]
    );

    const data = useMemo(() => users, [users]);

    return (
        <TableAdvanced
            columns={columns}
            data={data}
            renderRowSubComponent={renderRowSubComponent}
        />
    )
}

export default TableUsers;
